import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 3a1 1 0 0 1 1 1v16a1 1 0 0 1 -2 0v-16a1 1 0 0 1 1 -1","key":"svg-0"}],["path",{"d":"M18 8a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z","key":"svg-1"}]]

const IconLayoutAlignLeftFilled = createReactComponent('filled', 'layout-align-left-filled', 'LayoutAlignLeftFilled', __iconNode);

export default IconLayoutAlignLeftFilled;